import { logger } from "./logger";

/**
 * Телеметрія-seam контракт-дрейфу (ADR-0010 D8). `normalizeError` кличе це, коли
 * envelope бекенду не збігається з контрактом (відсутній/нерозпарсений `code`,
 * невідомий статус).
 *
 * Тіло поглинуте в logger-порт (ADR-0011 D4): `logger.warn('contract-drift', …)`.
 * **Публічний підпис і виклики з `normalizeError` — без змін** → 038-spec/тести зелені.
 * `warn` лишається видимим і в prod (≥ поріг) — дрейф контракту вартий уваги завжди.
 * `raw` навмисно НЕ передаємо в context (PII-межа §7 і так спроєктувала б його).
 */
export interface ContractDriftInfo {
  status?: number;
  code?: string;
  raw?: unknown;
}

export function reportContractDrift(info: ContractDriftInfo): void {
  logger.warn("contract-drift", {
    source: "http",
    status: info.status,
    code: info.code,
  });
}
